module.exports = __webpack_public_path__ + "img/server-rack.81c5df08.svg";